import formLock from "./formLock";

/* Модальное окно об отсутствии программ на странице программ */
function modalMissProgProgram(
  arr,
  region,
  submit,
  checkbox,
  Url,
  arrStatus,
  city
) {
  let shortUrl = location.href.split("/"),
    a = document.querySelector(".ProgramsModal__btn"),
    modal = document.createElement("div"),
    regionsArr = [],
    allProgramsRegionFiltred = [],
    firstArr,
    secondArr,
    modalRegions = document.querySelectorAll(".modal-programs"),
    statusCity = false;

  /* Если не сайт программы, прекращаем выполнение функции */
  if (!shortUrl.includes("program")) {
    return;
  }

  if (region && category) {
    /* Очищаем модальное окно */
    if (modalRegions.length > 0) {
      modalRegions.forEach((modal) => modal.remove());
    }

    /* Создаем модальное окно */
    if (!a) {
      (a = document.createElement("button")),
        a.setAttribute("data-modal-open", "");
      a.setAttribute("data-modal-id", "ProgramsModal");
      a.setAttribute("data-modal-close", "");
      a.classList.add("ProgramsModal__btn");
      a.style.display = "none";
      document.body.append(a);
    }

    /* Фильтрация общего массива по выбранному региону */
    allProgramsRegionFiltred = arr.filter((item) =>
      item.regions.some((it) => it.region_id == region)
    );

    /* Удаляем дубли в отфильтрованном массиве */
    let allProgramsNoDublicate = allProgramsRegionFiltred.filter(
      (item, idx, arr) => {
        return (
          arr.findLastIndex((it) => it.shortname === item.shortname) === idx
        );
      }
    );

    /* Проверка на доступность программы по выбранному городу */    
    allProgramsNoDublicate.forEach(i => {
      if (i.shortname == Url) {
        i.regions.forEach(j => {
          if (j.region_id == region) {
            j.cities.forEach(k => {
              if (k == city) {
                statusCity = true;
              }
            })
          }
        })
      }
    })

    /* Модальные окна */
    function createModal() {
      if (allProgramsNoDublicate.length == 0) {
        modal.classList.add("custom-modal__hidden", "modal-programs");
        modal.id = "ProgramsModal";
        modal.innerHTML = `<div class="modal-programs__content">
          <h3>К сожалению, в вашем регионе программа не&nbsp;реализуются</h3>
        </div>`;
        document.body.append(modal);
      } else if (arrStatus[0] == true && arrStatus[1] == false) {
        modal.classList.add("custom-modal__hidden", "modal-programs");
        modal.id = "ProgramsModal";

        if (statusCity == false && city) {
          modal.innerHTML = `<div class="modal-programs__content">
            <h3>К сожалению, в&nbsp;данном городе программа не&nbsp;реализуется</h3>
          </div>`;
        } else {
          modal.innerHTML = `<div class="modal-programs__content">
            <h3>К сожалению, по данному уровню образования программа не&nbsp;доступна</h3>
          </div>`;
        }
        
        document.body.append(modal);
      } else {
        modal.classList.add("custom-modal__hidden", "modal-programs");
        modal.id = "ProgramsModal";
        modal.innerHTML = `<div class="modal-programs__content">
          <h3>К сожалению, в вашем регионе программа не&nbsp;реализуется</h3>
          <p>Но вы все еще можете пройти <strong>бесплатное обучение</strong>
          и получить помощь в старте карьеры по другим программам. Вот какие программы доступны в вашем регионе:</p>
        <div class="modal-programs__links"></div>
        </div>`;
        document.body.append(modal);

        /* Заполняем список доступных программ. Также проверка на наличие shortname на лендинг */
        allProgramsNoDublicate.forEach((item) => {
          document.querySelector(".modal-programs__links").innerHTML += `
          ${
            item.shortname
              ? `<a href="/program/${item.shortname}">${item.name}</a>`
              : ""
          }
      `;
        });
      }
    }

    /* Фильтруем общий массив по shortname */
    let filterProgramsByshortname = arr.filter((it) => it.shortname == Url);

    /* Деструктуризируем отфильтрованный массив в переменную */
    if (filterProgramsByshortname.length > 1) {
      [firstArr, secondArr] = filterProgramsByshortname;
      regionsArr = firstArr.regions.concat(secondArr.regions);
    } else if (filterProgramsByshortname.length == 1) {
      [firstArr] = filterProgramsByshortname;
      regionsArr = firstArr.regions;
    }

    /* Проверяем есть ли в массиве выбранный регион */
    let findRedionId = regionsArr
      .map((it) => it.region_id)
      .find((it) => it == region);

    if (
      findRedionId === undefined ||
      (arrStatus[0] == true &&
        arrStatus[1] == false)
    ) {
      createModal();
      a.click();      
      formLock("lock");
    } else {
      formLock("unlock");
    }
  }
}

export default modalMissProgProgram;
